package gr.tech.pdfgenerator.models.projects

import gr.tech.pdfgenerator.models.GeneralInputsDTO
import gr.tech.pdfgenerator.models.MSAInputsDTO
import gr.tech.pdfgenerator.models.ProposalInputsDTO
import gr.tech.pdfgenerator.models.TierThreeDTO
import kotlinx.serialization.Serializable

@Serializable
data class ProjectDataDTO(
    val generalInputsState: GeneralInputsDTO,
    val msaInputsState: MSAInputsDTO,
    val propInputState: ProposalInputsDTO,
    val tierThreeState: TierThreeDTO
)
